
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifi2Google as ObiWifi2GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifi2-google.js';
 
 
 

 
 export const ObiWifi2Google = createComponent({
   react: React,
   tagName: 'obi-wifi2-google',
   elementClass: ObiWifi2GoogleElement,
   events: {
     
   }
  });
 
 